import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../../constants/colors'

interface NotificationWrapperProps {
  children: React.ReactNode
}

/**
 * Wraps a single notification with the shared backdrop and pointer-events so it’s clickable in the fixed container.
 */
export const NotificationWrapper: React.FC<NotificationWrapperProps> = ({ children }) => (
  <Box sx={{ pointerEvents: 'auto', position: 'relative' }}>
    <Box
      sx={{
        position: 'absolute',
        top: '-8px',
        left: '-8px',
        right: '-8px',
        bottom: '-8px',
        backgroundColor: INTERAX_COLORS.offBlack,
        borderRadius: '12px',
        zIndex: -1,
        opacity: 0.8
      }}
    />
    {children}
  </Box>
)
